// extracted by mini-css-extract-plugin
module.exports = {"InfoText":"style_InfoText__2S89R"};